import { render, staticRenderFns } from "./SwitchUserTypeModal.vue?vue&type=template&id=498d1389"
import script from "./SwitchUserTypeModal.vue?vue&type=script&lang=js"
export * from "./SwitchUserTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports